export default "__VITE_ASSET__kYdhbrzH__"